{
  "name": "patriot_ionic_2024",
  "version": "0.8.1.516",
  "author": "Ionic Framework",
  "homepage": "https://ionicframework.com/",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "proxy": "ng serve --proxy-config src/proxy.conf.json",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "-------------------------------------------------------------------DEBUG-----------------------------------------------------------------------------": "",
    "developer008": "npx ng build  --project=patriot_ionic_2024 --configuration=production && npx cap copy && ionic capacitor run android -l --host=192.168.80.78 --port 8100 -debug --target=d31fd89d0312",
    "-------------------------------------------------------------------PROD_BUILDS-----------------------------------------------------------------------": "",
    "build-prod-release": "npm run prepare-icons && ng build --configuration=production --aot && npm run web-config",
    "-------------------------------------------------------------------TEST_BUILDS-----------------------------------------------------------------------": "",
    "build-test": "npm run prepare-icons && ng build --configuration=testing --aot --stats-json && npm run web-config",
    "build-test-app": "ng build --configuration=testing --aot",
    "-------------------------------------------------------------------LOCAL_BUILDS-----------------------------------------------------------------------": "",
    "build-local": "ng build",
    "-------------------------------------------------------------------PREPARATION-----------------------------------------------------------------------": "",
    "prepare-icons": "ts-node ./scripts/icons_svg/prepare-icons.ts project=patriot",
    "-------------------------------------------------------------------ENVIRONMENT-----------------------------------------------------------------------": "",
    "web-config": "ts-node ./scripts/build/web-config.ts",
    "prebuild-teamcity": "node ./scripts/build/prebuild-teamcity.js build=YOUR_VERSION_HERE -L"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.1.3",
    "@angular/cdk": "^19.1.1",
    "@angular/common": "^19.1.3",
    "@angular/compiler": "^19.1.3",
    "@angular/core": "^19.1.3",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "^19.1.3",
    "@angular/material": "^19.1.1",
    "@angular/material-moment-adapter": "^19.2.17",
    "@angular/platform-browser": "^19.1.3",
    "@angular/platform-browser-dynamic": "^19.1.3",
    "@angular/router": "^19.1.3",
    "@angular/service-worker": "^19.1.3",
    "@capacitor/android": "^6.1.2",
    "@capacitor/app": "6.0.1",
    "@capacitor/browser": "^6.0.1",
    "@capacitor/clipboard": "^6.0.1",
    "@capacitor/core": "^6.1.2",
    "@capacitor/geolocation": "^6.0.1",
    "@capacitor/haptics": "6.0.1",
    "@capacitor/ios": "^6.1.2",
    "@capacitor/keyboard": "^6.0.2",
    "@capacitor/splash-screen": "^6.0.2",
    "@capacitor/status-bar": "^6.0.1",
    "@ionic/angular": "^8.3.3",
    "@ionic/pwa-elements": "^3.3.0",
    "@ionic/storage": "^4.0.0",
    "@ionic/storage-angular": "^4.0.0",
    "@maskito/angular": "^3.0.1",
    "@maskito/core": "^3.0.1",
    "@maskito/kit": "^3.0.1",
    "@maskito/phone": "^3.0.1",
    "@uralprombank/node-utils": "^0.2.712",
    "@yandex/ymaps3-default-ui-theme": "^0.0.19",
    "angularx-qrcode": "^19.0.0",
    "firebase": "^12.2.1",
    "ionicons": "^7.4.0",
    "libphonenumber-js": "^1.11.12",
    "ng2-pdf-viewer": "^10.4.0",
    "rxjs": "~7.8.1",
    "sha256": "^0.2.0",
    "tslib": "^2.8.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.1.4",
    "@angular-eslint/builder": "18.4.0",
    "@angular-eslint/eslint-plugin": "18.4.0",
    "@angular-eslint/eslint-plugin-template": "18.4.0",
    "@angular-eslint/schematics": "18.4.0",
    "@angular-eslint/template-parser": "18.4.0",
    "@angular/cli": "^19.1.4",
    "@angular/compiler-cli": "^19.1.3",
    "@angular/language-service": "^19.1.3",
    "@capacitor/cli": "^7.0.1",
    "@ionic/angular-toolkit": "^12.1.1",
    "@types/jasmine": "~5.1.4",
    "@types/node": "^22.8.2",
    "@types/sha256": "^0.2.2",
    "@typescript-eslint/eslint-plugin": "^8.12.1",
    "@typescript-eslint/parser": "^8.12.1",
    "@uralprombank/utils": "^0.2.841",
    "@yandex/ymaps3-types": "^1.0.15943616",
    "axios": "^1.7.7",
    "eslint": "^9.13.0",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-jsdoc": "^50.4.3",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "jasmine-core": "~5.4.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "svgo": "^3.3.2",
    "swiper": "^11.1.14",
    "ts-node": "^10.9.2",
    "typescript": "5.7.3"
  },
  "description": "Patriot project",
  "browserslist": [
    "Chrome >=79",
    "ChromeAndroid >=79",
    "Firefox >=70",
    "Edge >=79",
    "Safari >=14",
    "iOS >=14"
  ]
}
